import { deleteCookie, getCookie, hasCookie, setCookie } from 'cookies-next';
import { GetServerSidePropsContext, NextPageContext } from 'next';
import { OptionalTokenType } from 'urql/types';
import { getIsHttps, getProtocol } from 'utils/requestProtocol';

export const removeTokensFromCookies = (context?: GetServerSidePropsContext | NextPageContext): void => {
    deleteCookie('accessToken', { req: context?.req, res: context?.res, path: '/' });
    deleteCookie('refreshToken', { req: context?.req, res: context?.res, path: '/' });
};

export const setTokensToCookie = (
    accessToken: string,
    refreshToken: string,
    context?: GetServerSidePropsContext | NextPageContext,
): void => {
    setCookie('accessToken', accessToken, {
        req: context?.req,
        res: context?.res,
        path: '/',
        secure: getIsHttps(getProtocol(context)),
    });
    setCookie('refreshToken', refreshToken, {
        req: context?.req,
        res: context?.res,
        maxAge: 3600 * 24 * 14,
        path: '/',
        secure: getIsHttps(getProtocol(context)),
    });
};

export const hasTokenInCookie = (context?: GetServerSidePropsContext | NextPageContext): boolean => {
    return hasCookie('refreshToken', {
        req: context?.req,
        res: context?.res,
        secure: getIsHttps(getProtocol(context)),
    });
};

export const getTokensFromCookies = (context?: GetServerSidePropsContext | NextPageContext): OptionalTokenType => {
    let accessToken = getCookie('accessToken', { req: context?.req, res: context?.res });
    let refreshToken = getCookie('refreshToken', { req: context?.req, res: context?.res });

    if (typeof accessToken !== 'string') {
        accessToken = undefined;
    }

    if (typeof refreshToken !== 'string') {
        refreshToken = undefined;
    }

    return { accessToken, refreshToken };
};
